import { render, staticRenderFns } from "./csgIndex.vue?vue&type=template&id=37862fe2&scoped=true"
import script from "./csgIndex.vue?vue&type=script&lang=js"
export * from "./csgIndex.vue?vue&type=script&lang=js"
import style0 from "./csgIndex.vue?vue&type=style&index=0&id=37862fe2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37862fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37862fe2')) {
      api.createRecord('37862fe2', component.options)
    } else {
      api.reload('37862fe2', component.options)
    }
    module.hot.accept("./csgIndex.vue?vue&type=template&id=37862fe2&scoped=true", function () {
      api.rerender('37862fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/channel/online/csg/csgIndex.vue"
export default component.exports